import styled, { css } from 'styled-components';
export const TextArea = styled.textarea`
    resize: none;
    border: 0;
    outline: 0;
    width: 100%;
    line-height: 1.3;
    margin-bottom: 5px;
    min-height: 20px;
    font-size: 15px;
    color: #4a4a4a;
    background-color: #f5f5f5;
    font-family: Montserrat,Sans-serif;
    overflow-y: auto;
    &::-webkit-scrollbar{
        width: 5px;
        height: 2px;
    };
    &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
    };
`;